const config = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || (process.env.NODE_ENV === 'production'
        ? '/api'
        : 'http://localhost:5050/api'),
};

export default config;
